import { configureStore } from '@reduxjs/toolkit';
import usersReducer from './slices/usersSlice';
import loansReducer from './slices/loansSlice';
import loanApplicationsReducer from './slices/loanApplicationSlice';
import settingsReducer from './slices/settingsSlice';
import rolesReducer from './slices/roleSlice';
import adminReducer from './slices/adminSlice';
import featureConfigsReducer from './slices/featureConfigsSlice';
import apiLogsReducer from './slices/apiLogsSlice';
import secretReducer from './slices/secretSlice';
import pendingLoansReducer from './slices/pendingLoanSlice'
import paymentsReducer from './slices/paymentsSlice'
import mandatesReducer from './slices/mandatesSlice'
import payoutsReducer from './slices/payoutSlice'







 const store = configureStore({
  reducer: {
    users: usersReducer,
    loans: loansReducer,
    loanApplications: loanApplicationsReducer,
    settings: settingsReducer,
    roles:rolesReducer,
    admin:adminReducer,
    featureConfigs:featureConfigsReducer,
    apiLogs:apiLogsReducer,
    pendingLoans: pendingLoansReducer,
    secrets:secretReducer,
    payments: paymentsReducer,
    mandates:mandatesReducer,
    payouts:payoutsReducer
  },
});

export default store
